"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyStateText = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Text_1 = __importDefault(require("../../../Text"));
var Box_1 = __importDefault(require("../../../Box"));
exports.StyledEmptyStateText = styled_components_1.default(Box_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), style_utils_1.getColor("gray", 500));
var EmptyStateText = function (props) { return (react_1.default.createElement(exports.StyledEmptyStateText, { marginBottom: 3 },
    react_1.default.createElement(Text_1.default, __assign({}, props)))); };
exports.default = EmptyStateText;
var templateObject_1;
//# sourceMappingURL=index.js.map